/**
 * Created by superman on 17/2/16.
 */
import Vuex from 'vuex'
import Vue from 'vue'
import * as types from './type'

Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        hadorder: [],
        token: null,
        title: '',
        map:{}
    },
    mutations: {
        [types.LOGIN]: (state, data) => {
            localStorage.token = data;
            state.token = data;
        },
        [types.LOGOUT]: (state) => {
            localStorage.removeItem('token');
            state.token = null
        },
        [types.TITLE]: (state, data) => {
            state.title = data;
        },
        [types.INVOICE]:(state,data)=>{
            state.hadorder = data
        },
          [types.MAP]:(state,data)=>{
            state.map = data
          },
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js